import { LOCALSTORAGE_PLANT_PROFILE_SHOOT_TIME_EXPANDED } from "portal/utils/localStorage";
import { useCallback, useState } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";

/** Per-category accordion expand state, with a persisted default for unset ids. */
export const useShootTimeExpanded = (
  ids: readonly string[],
  storageKey = LOCALSTORAGE_PLANT_PROFILE_SHOOT_TIME_EXPANDED
): {
  isShootTimeExpanded: (id: string) => boolean;
  allShootTimeExpanded: boolean;
  setAllShootTimeExpanded: (expanded: boolean) => void;
  onShootTimeExpandedChange: (id: string, expanded: boolean) => void;
} => {
  const [expandedDefault, setExpandedDefault] = useLocalStorage(
    storageKey,
    true
  );
  const [expandedById, setExpandedById] = useState<Record<string, boolean>>({});

  const isShootTimeExpanded = (id: string): boolean =>
    expandedById[id] ?? expandedDefault;

  const allShootTimeExpanded = ids.every((id) => isShootTimeExpanded(id));

  const setAllShootTimeExpanded = (expanded: boolean): void => {
    setExpandedDefault(expanded);
    setExpandedById(Object.fromEntries(ids.map((id) => [id, expanded])));
  };

  const onShootTimeExpandedChange = useCallback(
    (id: string, expanded: boolean): void => {
      setExpandedById((prev) => ({
        ...prev,
        [id]: expanded,
      }));
    },
    []
  );

  return {
    isShootTimeExpanded,
    allShootTimeExpanded,
    setAllShootTimeExpanded,
    onShootTimeExpandedChange,
  };
};
